<template>
	<div>
		<div class="topTitle">项目维度数据</div>
		<div class="first_line">
			<div class="right_warp">
				<span class="demonstration">月份</span>
				<el-date-picker v-model="filter.month" type="month" placeholder="选择月" size="small"
					value-format="yyyy-MM">
				</el-date-picker>
				<el-select @change="getlist()" v-model="filter.storeId" placeholder="全部门店" clearable
					style="margin-left: 10px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					<el-option-group label="结业门店">
						<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
				</el-select>
				<el-select @change="getlist()" v-model="filter.type" placeholder="门店属性" clearable
					style="margin-left: 10px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-option-group>
				</el-select>
				<el-button type="primary" style=" position: relative;margin-left: 10px" @click="getlist()"
					size="small">筛 选</el-button>
			</div>
			<el-button type="info" style="dispaly:flex;float:right" size="small" @click="expro()">导出</el-button>
		</div>
		<div>
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
				tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="month" label="月份"></el-table-column>
				<el-table-column prop="serviceName" label="项目"></el-table-column>
				<el-table-column prop="newCustomer" label="新客数"></el-table-column>
				<el-table-column prop="serviceCustomer" label="总客数"></el-table-column>
				<el-table-column prop="meituanNewCustomer" label="美团新客数"></el-table-column>
				<el-table-column prop="meituanCustomer" label="美团单数"></el-table-column>
				<el-table-column prop="serviceInAll" label="项目占比" sortable>
					<template slot-scope="scope">
						{{scope.row.serviceInAll==null?"0":(scope.row.serviceInAll*100).toFixed(2)}}%
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	import format from "../../../utils/index.js"
	import {
		export2Excel
	} from '../../../common/js/util'
	export default {
		data() {
			return {
				tableData: [],
				filter: {
					month: new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ?'0'+( new Date().getMonth() + 1) :
						new Date().getMonth() + 1),
					storeId: "",
				},
				storeEnd: [],
				storeList: [],
				type: [{
						value: 1,
						label: "直营店"
					},
					// ,{
					// 	value:2,
					// 	label:"合作店"
					// },{
					// 	value:3,
					// 	label:"联名店"
					// },{
					// 	value:4,
					// 	label:"旗舰店"
					// },{
					// 	value:5,
					// 	label:"地铁店"
					// },
					{
						value: 6,
						label: "加盟店"
					}
				],
				// storeType:[{
				// 	value:0,
				// 	label:"直营店"
				// },{
				// 	value:1,
				// 	label:"加盟店"
				// }]
				columns: [{
					title: '月份',
					key: 'month'
				},{
					title: '项目',
					key: 'serviceName'
				}, {
					title: '新客数',
					key: 'newCustomer'
				}, {
					title: '总客数',
					key: 'serviceCustomer'
				}, {
					title: '美团新客数',
					key: 'meituanNewCustomer'
				}, {
					title: '美团单数',
					key: 'meituanCustomer'
				}, {
					title: '项目占比(%)',
					key: 'serviceInAll'
				}]
			};
		},
		mounted() {
			this.getStores()
			this.getlist()
		},
		methods: {
			// 获取门店列表
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			getlist() {
				var a = "?month=" + this.filter.month
				if (this.filter.storeId) {
					a = a + "&storeId=" + this.filter.storeId
				}
				if (this.filter.type) {
					a = a + "&type=" + this.filter.type
				}
				this.$http.get("data/serviceRevenueData" + a).then(
					function(res) {
						this.tableData = res.body.data
						this.tableData.map(ele=>{
							ele.serviceInAll = ele.serviceInAll/100
						})
					},
					function(err) {
						this.$message.error("请求失败")
					})
			},
			expro() {
				export2Excel(this.columns, this.tableData)
			}
		}
	};
</script>
<style lang="less" scoped>
	.topTitle {
		font-weight: blod;
		font-size: 22px;
		color: #707070;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}
	/deep/.el-select-dropdown__item {
		width:220px;
	}
</style>